import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Image, Modal, Row, message } from 'antd';
import React from 'react';
import { Images } from '../../../../controller/Images';
const CandidateDelete = ({
  candidateDeleteModalOpen,
  setCandidateDeleteModalOpen,
}) => {

  return (
    <Modal
      title=''
      open={candidateDeleteModalOpen}
      closeIcon={null}
      footer={null}
      width={350}
    >
      <div className='d-flex flex-column justify-content-center align-items-center text-center pt-4 gap-2'>
        <Image src={Images.deleteImg} alt='' preview={false} />
        <span className='fs-5 fw-semibold'>
          Are You Sure You Want
          <br /> To Delete{' '}
        </span>
        <p className='fs-6 opacity-50'>
          This will delete the candidates details and cannot be recovered
        </p>
        <Row className='w-100' gutter={[12, 12]}>
          <Col span={12}>
            <Button
              type='default'
              className='text-color-custom w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
              onClick={() => {
                setCandidateDeleteModalOpen(false);
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type='primary'
              className=' w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center button-color custom-hover-btn'
              
            >
              Yes
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default CandidateDelete;
